module.exports = __webpack_public_path__ + "static/media/img_352.076a0467.png";